module.exports = __webpack_public_path__ + "img/part2-6.77f79968.png";